import React, { useEffect, useRef, useState } from 'react'

import useUserInfo from 'hooks/useUserInfo'
import { ReactComponent as CheckIcon } from 'images/icon-check.svg'
import { ReactComponent as EditIcon } from 'images/icon-pencil.svg'
import { ReactComponent as HeaderIcon } from 'images/icon-team-members.svg'
import useUpdateUserProfile from 'services/firebase/hooks/users/useUpdateUserProfile'
import './TeamMembers.scss'

const TeamMembers = ({ handleEditing }) => {
  const elementRef = useRef(null)

  const [userInfo] = useUserInfo()
  const [edit, setEdit] = useState(false)
  const doUpdateUserProfile = useUpdateUserProfile()
  const [value, setValue] = useState(userInfo.numberOfEmployees)

  const handleEdit = () => {
    if (edit) {
      if (value) {
        doUpdateUserProfile({
          numberOfEmployees: parseInt(value),
        })
      }
      setEdit(false)
      handleEditing(null)
    } else {
      setEdit(true)
      handleEditing('members')
    }
  }

  useEffect(() => {
    if (edit) {
      elementRef.current.focus()
    }
  }, [edit])

  return (
    <div className={`m-teamMembers ${edit ? '-editing' : ''}`}>
      <div className='m-teamMembers__header'>
        <HeaderIcon />
        <button
          onClick={handleEdit}
          type='button'
          className={edit ? '-editing' : ''}
        >
          {edit ? <CheckIcon /> : <EditIcon />}
        </button>
      </div>
      <div className='m-teamMembers__main'>
        {edit ? (
          <div className='m-teamMembers__main--form'>
            <input
              ref={elementRef}
              value={value}
              type='number'
              onChange={(e) => setValue(e.target.value)}
            />
            <span>Team member</span>
          </div>
        ) : (
          <span>
            <b>{value}</b>
            Team <br />
            Member
          </span>
        )}
      </div>
    </div>
  )
}

export default TeamMembers
